import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Switch, Route, Link, useHistory } from 'react-router-dom'
import { ITrame } from './util'
import { Table, Button, Dropdown, Menu, Modal, Popover, Input } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { v4 as uuid } from 'uuid'
import Axios from 'axios'

interface IProps {
  trames: ITrame[]
  baseUrl: string
  onSave: (v: ITrame[]) => void
}

function copyTrameToNewOrga(trame: ITrame, orga: any) {
  let adhocdata = orga.adhoc_data? JSON.parse(orga.adhoc_data) : undefined
  if(adhocdata && Array.isArray(adhocdata)){
    adhocdata.push(trame)
  }
  else{
    adhocdata = [trame]
  }
  Axios.post("/organisations/adhoc_data/"+orga.orga_id, adhocdata)
}

function popoverContent(trame: ITrame) {

  const [orgas, setOrgas] = useState<any[]>([])
  const [filteredOrgas, setFilteredOrgas] = useState<any[]>([])

  useEffect(() => {
    if (orgas.length == 0) {
      Axios.get("/organisations/list").then((response) => {
        console.log(response.data)
        setOrgas(response.data)
        setFilteredOrgas(response.data)
      }, (error) => {
        console.log(error)
      })
    }
  })

  return (
    <div>
      <Input onChange={(e) => { setFilteredOrgas(orgas.filter((orga: any) => orga.name.toLowerCase().includes(e.currentTarget.value.toLowerCase()))) }} />
      <div style={{height: '100px', width: '500px', overflow: 'auto'}}>
        {filteredOrgas.map((e: any) => (
          <Button onClick={() => copyTrameToNewOrga(trame, e)} style={{ margin: '10px' }}>{e.name}</Button>
        ))}
      </div>
    </div>
  )
}

export const Trames = (props: IProps) => {
  const dataSource = props.trames
  const [popoverOpened, setPopoverOpened] = useState<boolean>(false)

  const handleMenuClick = (e: string, record: ITrame) => {
    console.log(e, record)
    if (e === 'clone') {
      const newTrames = props.trames.concat({ ...record, id: uuid() })
      props.onSave(newTrames)
    } else if (e === 'delete') {
      Modal.confirm({
        title: 'Certain·e de vouloir supprimer cette trame ?',
        icon: <ExclamationCircleOutlined />,
        content: 'vraiment certain·e ? ',
        onOk() {
          const newTrames = props.trames.filter((t) => t.id !== record.id)
          props.onSave(newTrames)
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    }
  }

  const columns = [
    {
      title: 'Nom',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '',
      width: 100,
      render: (k: string, record: ITrame) => {
        const v2UrlSupp = record.versionAdhoc == 2 ? "v2" : "v1"
        return (
          <Link to={`${props.baseUrl}/trames/${v2UrlSupp}/${record.id}`}>
            <Button type="link">Modifier</Button>
          </Link>
        )
      },
    },
    ,
    {
      title: '',
      width: 100,
      render: (k: string, record: ITrame) => {
        return (
          <Dropdown.Button
            trigger={['click']}
            onClick={() => setPopoverOpened(false)}
            onOpenChange={(e) => { setPopoverOpened(false) }}
            overlay={
              <Menu onClick={(e) => handleMenuClick(e.key.toString(), record)}>
                <Menu.Item key="clone">Cloner</Menu.Item>
                <Popover
                  content={() => popoverContent(record)}
                  title="Choisissez l'organisation de destination"
                  placement='left'
                  trigger={'click'}
                  open={popoverOpened}
                  showArrow={false}
                >
                  <Menu.Item onClick={() => setPopoverOpened(true)} key="cloneToOrga">Cloner vers une autre organisation</Menu.Item>
                </Popover>
                <Menu.Item key="delete">Supprimer</Menu.Item>
              </Menu>
            }
          ></Dropdown.Button>
        )
      },
    },
  ]

  return <Table dataSource={dataSource} columns={columns} rowKey="id" />
}
